import Interweave from 'interweave';
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Divider, Typography } from '@material-ui/core';

import HosoAbout from '../components/about';
import HosoProfile from '../components/profile';
import KPTable from '../../../../components/KPTComponents/KPTable';
import PreviewModal from '../../../../components/CustomComponents/PreviewModal';

import { profileActions } from '../../../../actions';
import { hoSoColumnMap, hoSoScoreColumns, hoSoEvidenceColumn } from '../../../../utils/qcv/hoSo.column_table';
import { APP_SCENE, ACHIEVEMENT_TYPE, KEYS } from '../../../../constants/enums';
import { capitalizeFirstLetter } from '../../../../utils';

// Thứ tự & tiêu đề các mục KHCN (A) — ĐỒNG BỘ với form Đăng ký hồ sơ
// (containers/QCV/DangKyHoSo/DangKyHoSoUpdate -> achievementEditors).
const KHCN_SECTIONS = [
  { formKey: 'formSolution', title: 'Bằng độc quyền sáng chế, giải pháp hữu ích thuộc lĩnh vực xét thưởng' },
  { formKey: 'formScientificResearch', title: 'Bài báo khoa học đăng trên tạp chí quốc tế, quốc gia thuộc lĩnh vực xét thưởng' },
  { formKey: 'formScientificReport', title: 'Bài báo khoa học đăng trên hội thảo quốc tế thuộc lĩnh vực xét thưởng' },
  { formKey: 'formResearchProject', title: 'Chương trình, dự án, đề tài nghiên cứu khoa học thuộc lĩnh vực xét thưởng' },
  { formKey: 'formMonograph', title: 'Sách chuyên khảo, giáo trình, chương sách thuộc lĩnh vực xét thưởng' },
  { formKey: 'formTechCompany', title: 'Sản phẩm khoa học công nghệ được ứng dụng thuộc lĩnh vực xét thưởng' },
  { formKey: 'formReward', title: 'Giải thưởng, huy chương đã đạt được thuộc lĩnh vực xét thưởng' },
];

export default function HoSoViewAdmin(props) {
  const dispatch = useDispatch();

  const [previewValue, setPreviewValue] = useState(null);

  const arrayPath = window.location.href.split('/');
  const urlId = parseInt(arrayPath.slice(arrayPath.length - 1));

  const profileId = useSelector((state) => state.profileReducer.profile?.id);
  const applicationList = useSelector((state) => state.formReducer.applicationList);
  const scoreInformationList = useSelector((state) => state.scoreInformationReducer.scoreInformationList);

  useEffect(() => {
    if (applicationList.length === 0) dispatch(profileActions.getProfileList());
  }, []);

  const applicationDetail = useMemo(() => {
    const filtered = applicationList.find((e) => e.id === urlId);
    const detail = { ...filtered };

    if (filtered) {
      Object.keys(ACHIEVEMENT_TYPE).forEach((_key) => {
        const key = 'form' + capitalizeFirstLetter(ACHIEVEMENT_TYPE[_key]);
        detail[key] = detail[key].map((e) => ({
          ...e[ACHIEVEMENT_TYPE[_key]],
          note: e.note,
          score: e.score,
          accepted: e.accepted,
        }));
      });
  
      const keyHr = 'form' + capitalizeFirstLetter(ACHIEVEMENT_TYPE.HR_DEVELOPMENT);
      detail[keyHr + KEYS.DAO_TAO] = detail[keyHr].filter((item) => item.type === KEYS.DAO_TAO);
      detail[keyHr + KEYS.BOI_DUONG] = detail[keyHr].filter((item) => item.type === KEYS.BOI_DUONG);

      detail.process = JSON.parse(detail.process || '[]');
      detail.socialActivity = JSON.parse(detail.socialActivity || '[]');
      detail.communicationActivity = JSON.parse(detail.communicationActivity || '[]');
      detail.hrTrainingActivity = JSON.parse(detail.hrTrainingActivity || '[]');
      detail.priority = JSON.parse(detail.priority || '{}');

      const fileList = JSON.parse(detail.previewFile || '[]');
      detail.sumaryFile = fileList.find((file) => file.includes(('sumaryFile')));
    }

    return detail;
  }, [applicationList]);

  // Hai quyền tách rời, thiếu prop thì fallback về `isSuperAdmin` như cũ:
  //   canViewOthers    - được mở hồ sơ của NGƯỜI KHÁC (gồm hội đồng bình chọn).
  //   showScoreColumns - hiện cột Điểm/Ghi chú của ban thư ký.
  const canViewOthers = props.canViewOthers ?? props.isSuperAdmin;
  const showScoreColumns = props.showScoreColumns ?? props.isSuperAdmin;
  if (!canViewOthers && applicationDetail?.profileId !== profileId) return null;

  return (
    <>
      <Grid container style={{ padding: 32 }}>
        <HosoProfile applicationDetail={applicationDetail} />
        <HosoAbout applicationDetail={applicationDetail} />

        <Grid item xs={5} style={{ marginTop: 32, marginBottom: 8 }}>
          <Box bgcolor='#c8c7cc' padding={1} fontSize={21}>
            QUÁ TRÌNH HỌC TẬP, CÔNG TÁC
          </Box>
        </Grid>
        <Grid item xs={7} />
        <Grid item xs={12}>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].hocTapCongTac()}
            rows={applicationDetail?.process}
          />
        </Grid>
        <Grid item xs={5} style={{ marginTop: 32, marginBottom: 8 }}>
          <Box bgcolor='#c8c7cc' padding={1} fontSize={21}>
            THÀNH TÍCH CÁ NHÂN
          </Box>
        </Grid>
        <Grid item xs={7} />
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Box display='flex'>
            <Box
              width={32}
              height={32}
              color='white'
              display='flex'
              bgcolor='black'
              borderRadius='50%'
              alignItems='center'
              justifyContent='center'
            >
              A
            </Box>
            <Box flexGrow={1} paddingLeft={4} lineHeight='32px'>
              <Typography variant='h6'>
                <b>THÀNH TÍCH KHOA HỌC CÔNG NGHỆ</b>
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {KHCN_SECTIONS.map((section, id) => (
            <React.Fragment key={section.formKey}>
              <Typography variant='h6' style={{ marginTop: id ? 32 : 8 }}>
                <b>{id + 1}. {section.title}</b>
                <br />
              </Typography>
              <KPTable
                nonBorder={false}
                columns={[
                  ...(hoSoColumnMap[APP_SCENE][section.formKey]?.(scoreInformationList) || []),
                  // Minh chứng: ai mở được hồ sơ cũng xem được (gồm ứng viên
                  // xem hồ sơ của chính mình) nên để ngoài điều kiện này.
                  ...(showScoreColumns ? hoSoScoreColumns : []),
                  hoSoEvidenceColumn,
                ]}
                rows={(applicationDetail[section.formKey] || []).filter((e) => e !== null)}
              />
              <Divider />
            </React.Fragment>
          ))}
        </Grid>

        {/* 8. Công trình tiêu biểu */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant='h6'>
            <b>8. Công trình tiêu biểu thuộc lĩnh vực xét thưởng</b>
          </Typography>
          {applicationDetail?.typicalWorkName ? (
            <Box marginTop={1}>
              <b>Tên công trình tiêu biểu: </b>
              {applicationDetail.typicalWorkName}
            </Box>
          ) : null}
          <Box marginTop={1}>
            <Interweave content={applicationDetail?.summary} />
          </Box>
          <Box marginTop={1}>
            {applicationDetail?.typicalWorkFile ? (
              <Typography
                variant='body1'
                color='primary'
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => setPreviewValue(applicationDetail.typicalWorkFile)}
              >
                File minh chứng công trình tiêu biểu
              </Typography>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                Chưa có file minh chứng
              </Typography>
            )}
          </Box>
        </Grid>

        {/* 9. Kế hoạch hành động và cam kết của ứng viên */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant='h6'>
            <b>9. Kế hoạch hành động và cam kết của ứng viên</b>
          </Typography>
          <Box marginTop={1}>
            {applicationDetail?.sumaryFile ? (
              <Typography
                variant='body1'
                color='primary'
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => setPreviewValue(applicationDetail.sumaryFile)}
              >
                Link file Cam kết của ứng viên
              </Typography>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                Chưa có file cam kết
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 64 }}>
          <Box display='flex'>
            <Box
              width={32}
              height={32}
              color='white'
              display='flex'
              bgcolor='black'
              borderRadius='50%'
              alignItems='center'
              justifyContent='center'
            >
              B
            </Box>
            <Box flexGrow={1} paddingLeft={4} lineHeight='32px'>
              <Typography variant='h6'>
                <b>THÀNH TÍCH KHEN THƯỞNG</b>
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Grid item xs={12}>
            <KPTable
              nonBorder={false}
              columns={hoSoColumnMap[APP_SCENE].thanhTichBangKhen((value) => setPreviewValue(value))}
              rows={applicationDetail?.communicationActivity}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 64 }}>
          <Box display='flex'>
            <Box
              width={32}
              height={32}
              color='white'
              display='flex'
              bgcolor='black'
              borderRadius='50%'
              alignItems='center'
              justifyContent='center'
            >
              C
            </Box>
            <Box flexGrow={1} paddingLeft={4} lineHeight='32px'>
              <Typography variant='h6' style={{ marginBottom: 10 }}>
                <b>THÀNH TÍCH HOẠT ĐỘNG CỘNG ĐỒNG</b>
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Typography variant='body1' style={{ marginBottom: 4 }}>
            <b>Hoạt động bồi dưỡng nhân lực (chia sẻ tri thức, chuyển giao KHCN,
            tập huấn...) trong lĩnh vực xét giải:</b>
          </Typography>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].boiDuongNhanLuc((value) => setPreviewValue(value))}
            rows={applicationDetail?.hrTrainingActivity}
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 16 }}>
          <Typography variant='body1' style={{ marginBottom: 4 }}>
            <b>Hoạt động tình nguyện vì cộng đồng nói chung:</b>
          </Typography>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].hoatDongCongDong((value) => setPreviewValue(value))}
            rows={applicationDetail?.socialActivity}
          />
        </Grid>

        {/* D. ƯU TIÊN */}
        <Grid item xs={12} style={{ marginTop: 64 }}>
          <Box display='flex'>
            <Box
              width={32}
              height={32}
              color='white'
              display='flex'
              bgcolor='black'
              borderRadius='50%'
              alignItems='center'
              justifyContent='center'
            >
              D
            </Box>
            <Box flexGrow={1} paddingLeft={4} lineHeight='32px'>
              <Typography variant='h6'>
                <b>ƯU TIÊN</b>
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Typography variant='body1'>
            • Là người dân tộc thiểu số:{' '}
            <b>{applicationDetail?.priority?.isEthnicMinority ? 'Có' : 'Không'}</b>
          </Typography>
          <Typography variant='body1'>
            • Là người khuyết tật:{' '}
            <b>{applicationDetail?.priority?.isDisabled ? 'Có' : 'Không'}</b>
          </Typography>
        </Grid>

        {/* File Kê khai thành tích cá nhân có xác nhận đóng dấu */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant='h6'>
            <b>File Kê khai thành tích cá nhân (có xác nhận đóng dấu)</b>
          </Typography>
          <Box marginTop={1}>
            {applicationDetail?.confirmationFile ? (
              <Typography
                variant='body1'
                color='primary'
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => setPreviewValue(applicationDetail.confirmationFile)}
              >
                File Kê khai thành tích cá nhân (có xác nhận)
              </Typography>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                Chưa có file xác nhận
              </Typography>
            )}
          </Box>
        </Grid>

      </Grid>

      <PreviewModal open={!!previewValue} url={previewValue} handleClose={() => setPreviewValue(null)} />
    </>
  );
}
